import * as React from 'react'
import styled from 'styled-components'
import { Style } from '../../styles'
import { WidgetSpace, WidgetSpaceType } from '../../types'
import Icon, { IconTypes } from '../../components/Icons/Icon'
import { useTranslation } from 'react-i18next'
import Switch from '../../components/Form/Switch'
import { DraggableProvided, DroppableProvided } from '@hello-pangea/dnd'

const Container = styled.div`
  display: flex;
  border: 1px solid ${Style.color.border};
  border-radius: 6px;
  min-height: 64px;
  padding: ${Style.spacing.x1};
  flex-direction: row;
  gap: ${Style.spacing.x1};
  background: white;
`

const DragHandle = styled.div`
  svg {
    width: 16px;
    height: 16px;
  }
`

const IconContainer = styled.div`
  svg {
    width: 16px;
    height: 16px;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
`

const Title = styled.div`
  font-size: 14px;
  font-weight: bold;
`

const Description = styled.div`
  font-size: 13px;
  color: #646462;
`

const Toggle = styled.div`


`

interface IProps {
  provided: DraggableProvided
  space: WidgetSpace
  onEnabledChange: (enabled: boolean) => void
}

const WidgetSpaceItem = (props: IProps) => {
  const { t } = useTranslation()
  const { space, provided } = props
  let icon: IconTypes = null
  let title = t(`WidgetSpaceType::${space.type}`)
  let description = ''

  switch (space.type) {
    case WidgetSpaceType.HOME:
      icon = 'messenger-home-active'
      description = t('SpaceItem::Make your Messenger personal')
      break
    case WidgetSpaceType.CONVERSATIONS:
      icon = 'messenger-conversations-active'
      description = t('SpaceItem::An inbox for conversations')
      break
    case WidgetSpaceType.HELP:
      icon = 'messenger-help-active'
      description = t('SpaceItem::In-Messenger Help Center')
      break
    case WidgetSpaceType.NEWS:
      icon = 'messenger-news-active'
      description = t('SpaceItem::Targeted newsfeed for announcements')
      break
    default:
      throw new Error(`Unknown space type`)
  }

  const onEnabledChange = () => {
    props.onEnabledChange(!space.enabled)
  }

  return (
    <Container ref={provided.innerRef} {...provided.draggableProps}>
      <DragHandle {...provided.dragHandleProps}>
        <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13 9C12.17 9 11.5 9.67 11.5 10.5C11.5 11.33 12.17 12 13 12C13.83 12 14.5 11.33 14.5 10.5C14.5 9.67 13.83 9 13 9ZM3 9C2.17 9 1.5 9.67 1.5 10.5C1.5 11.33 2.17 12 3 12C3.83 12 4.5 11.33 4.5 10.5C4.5 9.67 3.83 9 3 9ZM8 9C7.17 9 6.5 9.67 6.5 10.5C6.5 11.33 7.17 12 8 12C8.83 12 9.5 11.33 9.5 10.5C9.5 9.67 8.83 9 8 9ZM13 7C13.83 7 14.5 6.33 14.5 5.5C14.5 4.67 13.83 4 13 4C12.17 4 11.5 4.67 11.5 5.5C11.5 6.33 12.17 7 13 7ZM3 4C2.17 4 1.5 4.67 1.5 5.5C1.5 6.33 2.17 7 3 7C3.83 7 4.5 6.33 4.5 5.5C4.5 4.67 3.83 4 3 4ZM8 4C7.17 4 6.5 4.67 6.5 5.5C6.5 6.33 7.17 7 8 7C8.83 7 9.5 6.33 9.5 5.5C9.5 4.67 8.83 4 8 4Z"></path></svg>
      </DragHandle>

      <IconContainer>
        <Icon icon={icon} />
      </IconContainer>

      <Content>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </Content>

      <Toggle>
        <Switch
          name='enabled'
          checked={space.enabled}
          onClick={onEnabledChange}
        />
      </Toggle>

    </Container>
  )
}

export default WidgetSpaceItem